import { SoundingsData } from "../../entities";
import { FIXED_PROTOCOL_CONTENT_TYPE_IDS, FIXED_PROTOCOL_TYPE_IDS } from "../../utils/ProtocolTypeUtils";
import OldRecordsParser from './OldRecordsParser';
import { valueAsNumber } from './ParsingUtils';
import PropTransformer from './PropTransformer';
const SOUNDINGS_DATA_TAG = 'SoundingsData';
class SoundingsTransformer extends PropTransformer {
    toGateway(data) {
        if (data.soundings.length === 0) {
            return undefined;
        }
        return JSON.stringify(data.soundings);
    }
    fromGateway(soundings) {
        if (soundings) {
            const parsedSoundings = JSON.parse(soundings);
            parsedSoundings.forEach((sounding) => {
                sounding.portSounding = valueAsNumber(sounding.portSounding);
                sounding.centerSounding = valueAsNumber(sounding.centerSounding);
                sounding.starboardSounding = valueAsNumber(sounding.starboardSounding);
            });
            return { soundings: parsedSoundings };
        }
        return {};
    }
}
export default class SoundingsParser extends OldRecordsParser {
    constructor(app) {
        super(FIXED_PROTOCOL_TYPE_IDS.SOUNDINGS, FIXED_PROTOCOL_CONTENT_TYPE_IDS.SOUNDINGS, SOUNDINGS_DATA_TAG, app);
    }
    getPropsMapping() {
        return {
            soundings: new SoundingsTransformer(),
            freeText: 'freeText',
        };
    }
    createData(props) {
        const soundingsData = new SoundingsData();
        soundingsData.freeText = props.freeText;
        if (props.soundings) {
            soundingsData.soundings = props.soundings;
        }
        return soundingsData;
    }
}
//# sourceMappingURL=SoundingsParser.js.map